import { useEffect } from "react";
import { useLocation, Outlet } from "react-router-dom";
import { Nav } from "./Nav";
import { Footer } from "./Footer";

const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" });
    }, [pathname]);
    return null;
};

export const Layout = () => {
    return (
        <div className="App min-h-screen bg-white text-[#111111] flex flex-col">
            <ScrollToTop />
            <Nav />
            <main className="flex-1 pt-20 md:pt-24">
                <Outlet />
            </main>
            <Footer />
        </div>
    );
};
